import { EventEmitter, Injectable, Output, SimpleChanges } from '@angular/core';
import { GENERIC } from '../../util/login-modal.constant';
import { AnalyticsData } from './models/login-credentials.interface';

@Injectable()
export class LoginAuthenticationScreenExtendedComponent {
  @Output() redirectTrackingClick: EventEmitter<AnalyticsData> =
    new EventEmitter<AnalyticsData>();

  pageLoadStartTime: number;
  myTrip = false;
  needHelp = false;
  constructor() {
    this.pageLoadStartTime = performance.now();
  }

  onRedirectTracking(viewName: string): void {
    this.redirectTrackingClick.emit({ action: viewName });
  }

  resetPasswordSuccessEvent(successAdobeTracker: boolean): boolean {
    if (successAdobeTracker) {
      this.redirectTrackingClick.emit({
        action: GENERIC.LOGIN_SCREEN,
        eventDetails: GENERIC.CUSTOM
      });
    }
    return true;
  }

  addNeedHelpEventListener(message?: string, errorCode?: string): string {
    this.redirectTrackingClick.emit({
      action: 'Login Screen',
      eventDetails: 'error',
      errorMessage: message,
      errorCode: errorCode
    });
    setTimeout(() => {
      const formAlertElement =
        document.getElementsByTagName('idp-form-alert')[0];

      if (formAlertElement) {
        const anchors = formAlertElement.querySelector('a');
        if (anchors) {
          this.emitNeedHelp(anchors);
          this.emitMyTrip(anchors);
        }
      }
    }, 100);
    return message;
  }

  emitNeedHelp(anchors): void {
    if (anchors.href.includes('support-skymiles')) {
      anchors.addEventListener('click', (event) => {
        if (event && !this.needHelp) {
          this.needHelp = true;
          this.redirectTrackingClick.emit({ action: 'needHelp' });
        }
      });
    }
  }

  emitMyTrip(anchors): void {
    if (anchors.href.includes('my-trips/search')) {
      anchors.addEventListener('click', (event) => {
        if (event && !this.myTrip) {
          this.myTrip = true;
          this.redirectTrackingClick.emit({ action: 'myTrips' });
        }
      });
    }
  }

  public trackPageLoad(): void {
    if (this.pageLoadStartTime) {
      this.redirectTrackingClick.emit({
        action: 'Login Screen',
        eventDetails: 'pageLoad',
        startTime: this.pageLoadStartTime
      });
    }
  }

  checkSkyMilesNumber(changes: SimpleChanges): boolean {
    return (
      changes &&
      changes.content &&
      changes.content.currentValue &&
      changes.content.currentValue.skyMilesNumber
    );
  }
}
